import {Routes, RouterModule} from '@angular/router';

import {HelpComponent} from './help.component';
import {FormComponent} from './form/form.component';
import {ViewComponent} from './view/view.component';

const helpRoutes: Routes = [
  {path: '', redirectTo: 'help', pathMatch: 'full'},
  {path: 'help', component: HelpComponent},
  {path: 'help/new', component: FormComponent},
  {path: 'help/:codigo/edit', component: FormComponent},
  {path: 'help/:codigo', component: ViewComponent}
];

export const helpRouting = RouterModule.forChild(helpRoutes);




// WEBPACK FOOTER //
// ./src/app/help/help.routing.ts